import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  awslogo: {
    width: theme.spacing(5.875),
    height: theme.spacing(3.5),
    objectFit: 'contain',
  },
  azurelogo: {
    width: theme.spacing(4.125),
    height: theme.spacing(4.125),
    objectFit: 'contain',
  },
  gcpLogo: {
    width: theme.spacing(7),
    height: theme.spacing(4.375),
    objectFit: 'contain',
  },
  productNameContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    lineHeight: '0.8px',
  },
}))
